import { useState } from "react";
import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import CommentCard from "@/components/base/CommentCard";
import SectionHeading from "@/components/base/SectionHeading";

const picks = topics.slice(0, 6).map((topic) => ({
  topicId: topic.id,
  topicTitle: topic.title,
  category: topic.category,
  comment: topic.comments[0],
}));

export default function CommentWall() {
  const [liked, setLiked] = useState<string[]>([]);

  const toggleLike = (id: string) => {
    setLiked((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  return (
    <section className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="评论区高能回复"
        title="网友神评论精选"
        subtitle="从各个话题的评论区里挑出被反复引用的高能回复，既有情绪也有逻辑，先看它们再决定要不要下场。"
        linkTo="/topics"
        linkLabel="更多话题讨论"
      />
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        {picks.map((pick) => (
          <div key={pick.comment.id} className="flex flex-col gap-3">
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1 font-label text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1 text-secondary-700">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-chat-quote-line" aria-hidden="true" />
                </span>
                {pick.category}
              </span>
              <Link
                to={`/topics/${pick.topicId}`}
                className="cursor-pointer truncate transition-colors hover:text-primary-600"
              >
                {pick.topicTitle}
              </Link>
            </div>
            <CommentCard
              comment={pick.comment}
              liked={liked.includes(pick.comment.id)}
              onLike={toggleLike}
            />
          </div>
        ))}
      </div>
    </section>
  );
}